/**
 * Created by don on 3/6/15.
 */

"use strict";

var _ = require('underscore');
var SoaModel = require('bunsen/models/SoaModel');

var ASSOCIATIONS = ['nydc', 'aadla', 'twentiethLeague', 'adaa', 'aipad'];
var NYDC = 0;
var AADLA = 1;
var TWENTIETH = 2;
var ADAA = 3;
var AIPAD = 4;
var NAMES = {
    AADLA: 'AADLA',
    CINOA: 'CINOA',
    BADA: 'BADA',
    LAPADA: 'LAPADA',
    SLAD: 'SLAD',
    IFPDA: 'IFPDA',
    PADA: 'PADA',
    NADA: 'NADA',
    FADA: 'FADA',
    NAADAA: 'NAADAA',
    ADAA: 'ADAA',
    AAM: 'AAM',
    NYDC: 'NYDC',
    TWCS: 'TWCS',
    AIPAD: 'AIPAD'
};

/**
 * Contains information about associations to which the seller belongs.
 * @class TradeAssociation
 * @extends SoaModel
 */
var TradeAssociation = SoaModel.extend({

    /**
     * Set the URL for relevant service requests.
     * @returns {String}
     */
    url : function () {
        var url = _.result(this.parents[0], 'url') + '/tradeAssociations';

        return url;
    },

    isAntiquesAssociationLeague: function () {
        return TradeAssociation.OTHER_NAMES.indexOf(this.get('name')) > -1;
    }
}, {
    // deprecated - used in seller.associations.  Should use NAMES[association]
    ASSOCIATIONS:     ASSOCIATIONS,
    NYDC:             ASSOCIATIONS[NYDC],
    AADLA:            ASSOCIATIONS[AADLA],
    TWENTIETH_LEAGUE: ASSOCIATIONS[TWENTIETH],
    ADAA:             ASSOCIATIONS[ADAA],
    AIPAD:            ASSOCIATIONS[AIPAD],

    // new association names (used in seller.tradeAssociations)
    NAMES: NAMES,

    // Associations that are in the "Associations" dropdown. Basically not nydc,
    // 20th century, or AIPAD
    OTHER_NAMES: [
        NAMES.AADLA, NAMES.CINOA, NAMES.BADA, NAMES.LAPADA, NAMES.SLAD,
        NAMES.IFPDA, NAMES.PADA, NAMES.NADA, NAMES.FADA, NAMES.NAADAA,
        NAMES.ADAA
    ],

    /**
     *
     * @param {String} key
     * @returns {String}
     */
    getDisplayString : function (key) {
        var associationLabels = {
            nydc: 'NYDC',
            aadla: 'Antiques Association',
            twentiethLeague: '20th Century Specialists',
            adaa: 'ADAA',
            aipad: 'AIPAD'
        };

        return associationLabels[key];
    },

    getDisplayName : function (key) {
        var associationLabels = {
            nydc: 'NYDC Items',
            aadla: 'Antiques Associations Members',
            twentiethLeague: '20th Century Specialists',
            adaa: 'Art Dealers Associations',
            aipad: 'International Photography Art Dealers'
        };

        return associationLabels[key];
    }
});

module.exports = TradeAssociation;



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/identity/TradeAssociation.js
// module id = 2048
// module chunks = 63